import { styled } from 'styled-components';

const StatusCardStyle = styled.div<{ $level: number }>`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 180px;
  height: 240px;
  flex: none;
  padding: 0px 8px 8px 8px;
  flex-direction: column;
  justify-content: space-between;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  overflow: hidden;

  border-radius: 12px;
  background: ${(props) =>
    props.$level == 0
      ? 'radial-gradient(65.56% 49.17% at 50% 22.08%, rgba(212, 115, 50, 0.50) 0%, rgba(212, 115, 50, 0.00) 100%), #27262B'
      : props.$level == 1
        ? 'radial-gradient(65.56% 49.17% at 50% 22.08%, rgba(230, 179, 255, 0.25) 0%, rgba(149, 149, 149, 0.00) 100%), #27262B'
        : props.$level == 2
          ? 'radial-gradient(65.56% 49.17% at 50% 22.08%, rgba(255, 195, 0, 0.25) 0%, rgba(255, 195, 0, 0.00) 100%), #27262B'
          : 'radial-gradient(65.56% 49.17% at 50% 22.08%, rgba(110, 220, 255, 0.25) 0%, rgba(110, 220, 255, 0.00) 100%), #27262B'};
  @media (min-width: 768px) {
    width: 100%;
    height: auto;
    aspect-ratio: 264 / 352;
    flex: none;
  }
`;
const ActiveBg = styled.div<{ $level: number }>`
  position: absolute;
  width: 100%;
  height: 100%;

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  &:after {
    content: '';
    inset: -50%;
    position: absolute;
    top: -85%;

    background-image: url('/images/icons/status/active_level_${(props) =>
      props.$level}.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

    animation: rotate 10s linear 0s infinite;
  }
`;

const StatusCardContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 65%;
  align-items: center;
  justify-items: center;
  justify-content: flex-start;
  margin-top: 40px;
  flex-grow: 1;
  gap: 15px;
  @media (min-width: 768px) {
    margin-top: 52px;
    flex-grow: 1;
  }
`;
const StatusCardCrown = styled.div<{ 'data-image-url'?: string }>`
  width: 54px;
  height: 54px;
  background-image: url(${(props) => props['data-image-url']});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  @media (min-width: 768px) {
    width: 80px;
    height: 80px;
  }
`;
const StatusCardTitle = styled.div<{ $isActive: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  text-align: center;
  text-shadow: 0px 1.412px 1.412px rgba(11, 21, 46, 0.5);
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 110%;

  opacity: ${(props) => (props.$isActive ? '1' : '0.5')};
  @media (min-width: 768px) {
    font-size: 32px;
  }
`;
const DetailField = styled.div<{ $isActive: boolean }>`
  display: flex;
  min-height: 36px;
  padding: 6px 12px;
  justify-content: space-between;
  align-self: stretch;
  align-items: center;
  border-radius: 8px;
  background: #3d3c41;
  backdrop-filter: blur(8.810646057128906px);
  opacity: ${(props) => (props.$isActive ? '1' : '0.5')};
  flex-shrink: 0;
  gap: 8px;
  @media (min-width: 768px) {
    min-height: 54px;
  }
`;
const DetailLabel = styled.div`
  color: #fff;
  text-align: center;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  text-transform: capitalize;
  @media (min-width: 768px) {
    font-size: 20px;
  }
`;
const DetailValue = styled.div<{ $compact?: boolean }>`
  color: #fff;
  text-align: right;
  text-shadow: 0px 1.412px 1.412px rgba(11, 21, 46, 0.5);
  font-family: Rubik;
  font-size: ${(props) => (props.$compact ? '14px' : '20px')};
  font-style: normal;
  font-weight: 700;
  line-height: 110%;
  white-space: nowrap;
  flex-shrink: 0;
  @media (min-width: 768px) {
    font-size: ${(props) => (props.$compact ? '20px' : '32px')};
  }
`;
const ProgressBarLabel = styled.div`
  color: #fff;
  text-align: center;
  font-family: Rubik;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  position: relative;
  z-index: 1;
  @media (min-width: 769px) {
    font-size: 14px;
  }
`;
const ProgressBar = styled.div<{ $progress: number }>`
  width: 120px;
  height: 12px;
  flex-shrink: 0;
  border-radius: 12px;
  border:
    1px solid linear-gradient(89deg, #ff9500 0.66%, #ff5e00 116.39%),
    linear-gradient(126deg, #5bdbff 1.05%, rgba(91, 219, 255, 0) 46.67%),
    #2672ff;
  background: #27262b;
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${(props) => props.$progress}%;
    border-radius: 12px;
    background:
      linear-gradient(89deg, #ff9500 0.66%, #ff5e00 116.39%),
      linear-gradient(126deg, #5bdbff 1.05%, rgba(91, 219, 255, 0) 46.67%),
      #2672ff;
    border-radius: 12px;
  }

  @media (min-width: 768px) {
    width: 178px;
    height: 18px;
  }
`;

export {
  StatusCardStyle,
  ActiveBg,
  StatusCardContent,
  StatusCardCrown,
  StatusCardTitle,
  DetailField,
  DetailLabel,
  DetailValue,
  ProgressBarLabel,
  ProgressBar,
};
